import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { GroupedObservable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, groupBy } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { LoadingService } from 'src/app/core/services/loader.service';
import { UsersService } from '../users/services/users.service';
import { UserNotificationPopupComponent } from './user-notification-popup/user-notification-popup.component';

@Component({
  selector: 'app-user-notification',
  templateUrl: './user-notification.component.html',
  styleUrls: ['./user-notification.component.scss'],
})
export class UserNotificationComponent implements OnInit {
  allNotification = [];
  filteredNotification = [];
  contactId: string;
  accountId: string;
  selectedNotification = [];
  currentThread = [];
  userFullName;
  userdata;
  currentIndex: number;
  // description: string;
  currentSubject: string;
  public token;
  searchSubject = new Subject();
  // header = 'Notifications';
  // currentStage = 0;
  // totalStage = 0;
  constructor(
    private loadingService: LoadingService,
    private userService: UsersService,
    public auth: AuthenticationService,
    public dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.token = this.auth.getUserAccessToken();
    this.accountId = this.auth.getUserAccountId();
    this.contactId = this.auth.getPrimaryUserId();
    this.userdata = this.auth.getDecodedUserAccessToken();
    this.userFullName = this.userdata.contactDetails[0].fullname.split(' ');
    this.searchSubject
      .pipe(debounceTime(100), distinctUntilChanged())
      .subscribe((value: string) => {
        this._filterNotification(value);
      });
    this.getNotification();
  }
  getNotification() {
    this.selectedNotification = [];
    this.loadingService.startLoading();
    this.userService
      .getUserNotification(this.token, this.contactId, this.accountId)
      .subscribe(
        (response) => {
          // console.log('data we get');
          // console.log(response);
          this.allNotification = [];
          if (response.data && response.data.result2) {
            // const openNotifi = [];
            // const completeNotifi = [];
            const ungroupNotification = [];
            response.data.result2.forEach((element) => {
              const maskDetail = response.data.result.find((a) => {
                return a._activityid_value == element.activityid;
              });
              let createdBy = 'Cashel Developer';
              let createdBySlug = 'CD';
              if (maskDetail.participationtypemask == 1) {
                const created = maskDetail._partyid_value_Formatted.split(' ');
                //  createdBy = maskDetail._partyid_value_Formatted
                createdBy = 'You';
                createdBySlug = created[0].charAt(0) + created[1].charAt(0);
              }

              const notification = {
                mask: maskDetail.participationtypemask,
                createdOn: element.createdon_Formatted,
                subject: element.subject,
                description: element.description,
                statecode: element.statecode,
                statuscode: element.statuscode,
                activityid: element.activityid,
                // createdBy: element._createdby_value_Formatted,
                // createdBySlug: createdBy[0].charAt(0) + createdBy[1].charAt(0),
                createdBy,
                createdBySlug,
                //  regarding: element._regardingobjectid_value_Formatted,
                //  regardingId: element._regardingobjectid_value,
              };
              ungroupNotification.push(notification);
              // if (notification.statecode == 0) {
              //   openNotifi.push(notification);
              // } else {
              //   completeNotifi.push(notification);
              // }
              //  this.allNotification.push(notification);
            });
            //  this.allNotification = [...openNotifi, ...completeNotifi];
            // console.log('ungroupNotification');
            // console.log(ungroupNotification);
            const groupedResult = ungroupNotification.reduce(function (r, a) {
              r[a.subject] = r[a.subject] || [];
              r[a.subject].push(a);
              return r;
            }, Object.create(null));
            // console.log('groupedResult');
            // console.log(groupedResult);
            // this.allNotification=groupedResult
            const notificationInArray = [];
            for (const notifi in groupedResult) {
              // //console.log(notifi);
              const a = [];
              groupedResult[notifi].forEach((element) => {
                //  //console.log(element);
                a.push(element);
              });
              notificationInArray.push({ subject: a[0].subject, allnotifi: a });
            }
            // notificationInArray.reverse();
            this.allNotification = notificationInArray;
            this._filterNotification('');
          }
          // console.log('all notification');
          // console.log(this.allNotification);
          this.loadingService.stopLoading();
        },
        (err) => {
          this.loadingService.stopLoading();
          console.log('error', err);
          this.auth.showSnackBarMsg('Something went wrong!')
        }
      );
  }
  showfullNotifi(data, subject: string) {
    const i = this.allNotification.findIndex((a) => a.subject === subject);
    const newData = [...data];
    if (this.currentIndex == i) {
      this.currentThread = [];
      this.currentSubject = '';
      this.currentIndex = -1;
    } else {
      this.currentIndex = i;
      this.currentSubject = subject;
      this.currentThread = newData.reverse();
    }
  }

  sentMessage(description) {
    if (description.value.trim().length > 0) {
      const formdata = {
        description: description.value.trim(),
        subject: this.currentThread[0].subject,
        // regarding: this.currentThread[0].regardingId,
        contactId: this.contactId,
        accountId: this.accountId,
      };
      // console.log(formdata);
      this.loadingService.startLoading();
      this.userService.addNotification(this.token, formdata).subscribe(
        (data) => {
          this.loadingService.stopLoading();
          // console.log(data);
          description.value = '';
          //  const created = this.auth.getLoginUserName();
          const notification = {
            mask: 1,
            createdOn: new Date().toLocaleString(),
            subject: formdata.subject,
            description: formdata.description,
            statecode: 0,
            statuscode: 1,
            activityid: data.data,
            // createdBy: element._createdby_value_Formatted,
            // createdBySlug: createdBy[0].charAt(0) + createdBy[1].charAt(0),
            createdBy: 'You',
            createdBySlug:
              this.userFullName[0].charAt(0) + this.userFullName[1].charAt(0),
            // regarding: element._regardingobjectid_value_Formatted,
            // regardingId: element._regardingobjectid_value,
          };
          // console.log('new notification', notification);
          this.currentThread.push(notification);
          // this.allNotification[this.currentIndex].push(notification);
          // this.allNotification[this.currentIndex].insert(0, notification);
          this.allNotification[this.currentIndex].allnotifi.splice(
            0,
            0,
            notification
          );
        },
        (error) => {
          console.log(error);
          this.loadingService.stopLoading();
          this.auth.showSnackBarMsg('Something went wrong!')
        }
      );
    } else {
      this.auth.showSnackBarMsg('Please write description!')
      return;
    }
  }
  searchNotification(value: string) {
    this.searchSubject.next(value);
  }
  onBack() {
    const backUrl = this.auth.getbackNotificationurl();
    // console.log(backUrl);
    if (backUrl) {
      // this.router.navigate([`${backUrl}`]);
      this.auth.gotoUrl(`${backUrl}`);
    } else {
      this.auth.showSnackBarMsg('You can not go back, Please login again')
    }
  }
  compose() {
    const dialogRef = this.dialog.open(UserNotificationPopupComponent, {
      maxWidth: '600px',
      width: '100%',
      position: { right: '0', bottom: '0' },
    });
    dialogRef.afterClosed().subscribe((result) => {
      // console.log(`Dialog result: ${result}`);
      if (result) {
        this.getNotification();
      }
    });
  }
  private _filterNotification(value: string) {
    // console.log(value);
    const filterValue = value.toLowerCase();
    if (filterValue.trim().length > 0) {
      this.filteredNotification = [];
      this.allNotification.forEach((notifi) => {
        let flag;
        notifi.allnotifi.forEach((element) => {
          if (
            element.subject.toLowerCase().includes(filterValue) ||
            element.description.toLowerCase().includes(filterValue)
          ) {
            flag = true;
          }
        });
        if (flag == true) {
          this.filteredNotification.push(notifi);
        }
      });
      // console.log(this.filteredNotification);
    } else {
      this.filteredNotification = this.allNotification;
    }
  }
}
